import React from 'react'

const ICON_PATHS = {
  industry: (
    <>
      <path d='M4 19V9l5 3V9l5 3V7h4v12H4Z' />
      <path d='M8 19v-3m4 3v-3m4 3v-3' />
    </>
  ),
  receipt: (
    <>
      <path d='M7 3h10v18l-2-1.3-2 1.3-2-1.3-2 1.3-2-1.3L5 21V5a2 2 0 0 1 2-2Z' />
      <path d='M9 8h6M9 12h6M9 16h4' />
    </>
  ),
  landmark: (
    <>
      <path d='M4 9h16L12 4 4 9Z' />
      <path d='M6 10v7m4-7v7m4-7v7m4-7v7M4 20h16' />
    </>
  ),
  globe: (
    <>
      <circle cx='12' cy='12' r='8' />
      <path d='M4 12h16M12 4c2 2.2 3 4.9 3 8s-1 5.8-3 8c-2-2.2-3-4.9-3-8s1-5.8 3-8Z' />
    </>
  ),
  bank: (
    <>
      <path d='M5 9h14M7 9v8m4-8v8m4-8v8m4 3H5m1-11 6-4 6 4' />
    </>
  ),
  chartLine: (
    <>
      <path d='M4 19h16' />
      <path d='m5 15 4-4 3 3 6-7' />
      <path d='M16 7h2v2' />
    </>
  ),
  grid: (
    <>
      <rect x='4' y='4' width='6' height='6' rx='1' />
      <rect x='14' y='4' width='6' height='6' rx='1' />
      <rect x='4' y='14' width='6' height='6' rx='1' />
      <rect x='14' y='14' width='6' height='6' rx='1' />
    </>
  ),
  folderTree: (
    <>
      <path d='M4 6h6l2 2h8v5H4V6Z' />
      <path d='M7 13v5h5m0 0v-2h6v4h-6v-2Z' />
    </>
  ),
  bolt: <path d='M13 2 5 13h6l-1 9 9-13h-6l0-7Z' />,
  compass: (
    <>
      <circle cx='12' cy='12' r='8' />
      <path d='m15.5 8.5-2 5-5 2 2-5 5-2Z' />
    </>
  ),
  chartColumn: (
    <>
      <path d='M4 20h16' />
      <path d='M7 16V9m5 7V5m5 11v-5' />
    </>
  ),
  flask: (
    <>
      <path d='M9 3h6M10 3v5l-5 9a3 3 0 0 0 2.6 4h8.8A3 3 0 0 0 19 17l-5-9V3' />
      <path d='M8 15h8' />
    </>
  ),
  searchChart: (
    <>
      <circle cx='10' cy='10' r='5' />
      <path d='m14 14 5 5M8 11v2m2-5v5m2-3v3' />
    </>
  ),
  database: (
    <>
      <ellipse cx='12' cy='5' rx='7' ry='3' />
      <path d='M5 5v6c0 1.7 3.1 3 7 3s7-1.3 7-3V5' />
      <path d='M5 11v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6' />
    </>
  ),
  search: (
    <>
      <circle cx='10.5' cy='10.5' r='6.5' />
      <path d='m15.5 15.5 4 4' />
    </>
  ),
  check: <path d='m5 12 4 4 10-10' />,
  pdf: (
    <>
      <path d='M7 3h7l4 4v14H7V3Z' />
      <path d='M14 3v5h4M9 14h6M9 17h4' />
    </>
  ),
}

function LandingIcon({ name = 'chartLine', className = '', size = 22 }) {
  return (
    <svg
      className={`landing-svg-icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.9'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      focusable='false'
    >
      {ICON_PATHS[name] || ICON_PATHS.chartLine}
    </svg>
  )
}

export default LandingIcon
